<template>
  <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <template v-if="name === 'person'"><circle cx="16" cy="10" r="5"/><path d="M6 28v-3a10 10 0 0 1 20 0v3M12 23l4 4 4-4"/></template>
    <template v-else-if="name === 'report'"><path d="M19 3H7v26h19V10L19 3Z M19 3v8h7M11 17h10M11 22h7"/><path d="m10 9 2 2 3-4"/></template>
    <template v-else-if="name === 'tax'"><rect x="4" y="4" width="24" height="24" rx="7"/><path d="m10 23 12-14"/><circle cx="11" cy="11" r="2"/><circle cx="21" cy="21" r="2"/></template>
    <template v-else-if="name === 'chat'"><path d="M5 5h22v17H15l-8 6v-6H5V5Z M11 12h10M11 17h6"/></template>
    <template v-else-if="name === 'arrow'"><path d="M6 16h20M18 8l8 8-8 8"/></template>
    <template v-else><path d="m7 17 6 6L26 9"/></template>
  </svg>
</template>
<script>
export default { props: { name: {type:String,default:'check'} } }
</script>
